/**
 * Tokens del sistema visual del sitio público (Landing, Comparativa,
 * Methodology, PublicNav, PulseDot).
 *
 * Punto único de definición — si cambia la marca, se cambia acá y se
 * propaga a todas las páginas públicas.
 *
 * NOTA: estos tokens son SEPARADOS del sistema de la console autenticada
 * (`tokens/dgl`), porque el público tiene una identidad editorial
 * (Fraunces, JetBrains Mono) distinta del backoffice.
 */

// === Color primario y signal ===
export const PRIMARY = '#00A3E0';        // Cyan editorial — usado para CTAs, links, acentos
export const SIGNAL = '#00FFA8';         // Verde de "señal en vivo" — usado para indicadores activos

// === Backgrounds (orden: claro → oscuro) ===
export const BG = '#0A0E14';             // Background principal de página
export const BG_DARKER = '#050810';      // Background "más profundo" (nav, hero secundario)
export const BG_CARD = '#0F141C';        // Background de cards y containers

// === Borders (orden: sutil → más visible) ===
export const BORDER = '#1A2332';         // Border default — separadores, cards
export const BORDER_STRONG = '#2A3648';  // Border destacado — hover, estados activos

// === Texto (orden: prominente → tenue) ===
export const TEXT = '#F0F2F5';           // Texto principal
export const TEXT_DIM = '#8A95A8';       // Texto secundario, descripciones
export const TEXT_FAINT = '#525E70';     // Texto terciario, metadatos, deshabilitado

// === Tonos contextuales ===
export const APPLE_TONE = '#6B7280';     // Gris neutro — usado en mockups que representan "el otro lado" (Apple Watch) para no inducir asociación de marca
